import React from 'react';
import { isEmail } from '@/utils/helpers';

export const useEmailBlacklist = ({
  emailBlacklistErrorMessage = '',
  emailFieldname = '',
  emailsBlacklisted = [''],
}) => {
  const [messageBarOpen, setMessageBarOpen] = React.useState<boolean>(false);

  const handleCloseMessageBar = React.useCallback(() => {
    setMessageBarOpen(false);
  }, []);

  const handleOpenMessageBar = React.useCallback(() => {
    setMessageBarOpen(true);
  }, []);

  const errorMessageBarProps = React.useMemo(
    () => ({
      isOpen: messageBarOpen,
      onClose: handleCloseMessageBar,
      message: emailBlacklistErrorMessage,
      autoHideDuration: 6000,
    }),
    [emailBlacklistErrorMessage, handleCloseMessageBar, messageBarOpen],
  );

  // ********** //

  const verifyMail = React.useCallback(
    ({ fieldname = '', blacklist = [''] }) =>
      (formValues = {}) => {
        const email = (((formValues as any)?.[fieldname] as string) || '').toLowerCase();
        const domain = email.split('@')?.[1] || '';

        const isBlacklisted = !!blacklist.find((emailBlacklisted: string) => {
          // CASE 1: blacklist item is a domain restriction rule.
          if (!isEmail(emailBlacklisted)) return emailBlacklisted.toLowerCase() === domain;

          // CASE 2: blacklist item is a specific email restriction rule.
          return emailBlacklisted.toLowerCase() === email;
        });

        if (isBlacklisted) handleOpenMessageBar();

        return isBlacklisted;
      },
    [handleOpenMessageBar],
  );

  return {
    errorMessageBarProps,
    verifyMail: verifyMail({ fieldname: emailFieldname, blacklist: emailsBlacklisted }),
  };
};
